import React from "react";

/*eslint-disable*/

interface PropertiesLayouts {
  layoutsArray: any;
}

interface Props {
  showLayouts: boolean;
  angle: number;
  scriptData: any;
  handleShowTooltip: any;
  colorsData: any;
  propertiesData: any;
  propertyFilterArray: any;
  avalabilityAttributesToShow: any;
  hasDispo: boolean;
  links: any;
}

interface State {
  angle: number;
  showLayouts: boolean;
  rgbaColor: any;
  hslColor: any;
  filteredData: any;
  isFilterActive: boolean;
  currentSelectedProperty: string;
  isMouseDown: boolean;
  isMouseMoving: boolean;
  colorsObject: any;
  attributeId: any;
}

class PropertiesLayouts extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      angle: 0,
      showLayouts: false,
      rgbaColor: "",
      hslColor: "",
      filteredData: [],
      isFilterActive: false,
      currentSelectedProperty: "",
      isMouseDown: false,
      isMouseMoving: false,
      colorsObject: {},
      attributeId: "",
    };
  }

  componentDidMount(): void {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
      this.props.colorsData.main_buttons
    );
    this.setState(
      {
        rgbaColor: result
          ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
            }
          : "",
      },
      () => {
        var r, g, b;
        r = this.state.rgbaColor.r / 255;
        g = this.state.rgbaColor.g / 255;
        b = this.state.rgbaColor.b / 255;

        const l = Math.max(r, g, b);
        const s = l - Math.min(r, g, b);
        const h = s
          ? l === r
            ? (g - b) / s
            : l === g
            ? 2 + (b - r) / s
            : 4 + (r - g) / s
          : 0;

        var resultHSL = {
          h: 60 * h < 0 ? 60 * h + 360 : 60 * h,
          s:
            100 *
            (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
          l: (100 * (2 * l - s)) / 2,
        };

        this.setState({
          hslColor: resultHSL,
        });
      }
    );
    this.setState(
      {
        showLayouts: true,
      },
      () => {
        this.updateLayoutsInfo();
      }
    );

    document.addEventListener("mousedown", () => {
      this.setState({
        isMouseDown: true,
      });
    });
    document.addEventListener("mouseup", () => {
      this.setState({
        isMouseDown: false,
        isMouseMoving: false,
      });
    });
    document.addEventListener("mouseleave", () => {
      this.setState({
        isMouseDown: false,
        isMouseMoving: false,
      });
    });
    document.addEventListener("mousemove", () => {
      if (this.state.isMouseDown) {
        this.setState({
          isMouseMoving: true,
        });
      }
    });
  }

  updateLayoutsInfo = () => {
    if (
      this.props.propertiesData &&
      this.props.propertiesData.property &&
      this.props.propertiesData.attributes &&
      this.props.scriptData
    ) {
      this.props.propertiesData.property.map((property: any, index: number) =>
        this.props.scriptData.properties_coord_file.map(
          (frame: any, indexFrame: number) =>
            frame.properties.map(
              (frameProperty: any, indexFrameProperty: number) => {
                var tempValuesArray: any = [];
                if (frameProperty.id === property.id) {
                  property.values.map((value: any, indexValue: number) => {
                    tempValuesArray[value.attribute] = value.value;
                    tempValuesArray[property.id] = property.property;
                  });
                  frameProperty.values = tempValuesArray;
                  frameProperty.availability = property.availability;
                }

                return 0;
              }
            )
        )
      );

      var tempColors: any = {};
      this.props.propertiesData.attributes.map((attribute: any) => {
        if (attribute.name === "Apto tipo") {
          attribute.values.map((value: any) => {
            if (value.layoutFill !== null) {
              tempColors[value.value] = this.handleGetBubbleColor(
                value.layoutFill
              );
            }
          });
          this.setState({
            attributeId: attribute.id,
          });
        }
      });

      this.setState({
        colorsObject: tempColors,
      });
    }
  };

  handleGetBubbleColor = (payload: any) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(payload);

    var rgbaColor: any = result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : "";

    var r, g, b;
    r = rgbaColor.r / 255;
    g = rgbaColor.g / 255;
    b = rgbaColor.b / 255;

    const l = Math.max(r, g, b);
    const s = l - Math.min(r, g, b);
    const h = s
      ? l === r
        ? (g - b) / s
        : l === g
        ? 2 + (b - r) / s
        : 4 + (r - g) / s
      : 0;

    var resultHSL = {
      h: 60 * h < 0 ? 60 * h + 360 : 60 * h,
      s: 100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
      l: (100 * (2 * l - s)) / 2,
    };

    return resultHSL;
  };

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (
      this.props.scriptData !== prevProps.scriptData &&
      this.props.scriptData.properties_coord_file
    ) {
      this.setState(
        {
          showLayouts: true,
        },
        () => {
          this.updateLayoutsInfo();
        }
      );
    }
    if (
      prevProps.showLayouts !== this.props.showLayouts &&
      this.props.showLayouts
    ) {
      this.createLayouts();
    }
    /*if (prevProps.angle !== this.props.angle && this.props.showLayouts) {
      this.createLayouts();
    }*/
    if (
      prevProps.propertyFilterArray &&
      this.props.propertyFilterArray &&
      this.props.propertyFilterArray.length > 0
    ) {
      this.createLayouts();
    }
    if (
      prevProps.avalabilityAttributesToShow !==
      this.props.avalabilityAttributesToShow
    ) {
      this.createLayouts();
    }
    if (prevProps.links !== this.props.links) {
      this.createLayouts();
    }
  }

  clearLayoutFilter = () => {
    this.setState({
      currentSelectedProperty: "",
    });
  };

  createLayouts = () => {
    if (
      this.props.scriptData.properties_coord_file &&
      this.props.scriptData.properties_coord_file[this.props.angle]
    ) {
      if (
        this.props.scriptData.properties_coord_file[this.props.angle].properties
          .length > 0
      ) {
        var bubblesToShow: any =
          this.props.scriptData.properties_coord_file[
            this.props.links.length === 50
              ? this.props.angle * 2
              : this.props.angle
          ].properties;

        var tempArrayDropdown: any = [];
        var tempAvailabilityArray: any = [];

        console.log(this.props.propertyFilterArray);

        Object.keys(this.props.propertyFilterArray).map(
          (key: any, index: number) => {
            var tempArray: any = [];
            console.log(key);
            console.log(this.props.propertyFilterArray[key]);

            bubblesToShow.map((property: any) => {
              if (this.props.propertyFilterArray[key].length > 0) {
                if (
                  property.hasOwnProperty("values") &&
                  this.props.propertyFilterArray[key].includes(
                    property.values[key]
                  )
                ) {
                  console.log(property);
                  console.log(this.props.propertyFilterArray);

                  console.log(key);

                  console.log(property.values[key]);
                  if (
                    !Array.isArray(this.props.propertyFilterArray[key]) && this.props.propertyFilterArray[key] === property.values[key]
                  ) {
                    tempArray.push(property);
                  }else if (Array.isArray(this.props.propertyFilterArray[key])) {
                    tempArray.push(property)
                  }{

                  }
                }
              } else {
                //console.log(property);
                tempArray.push(property);
              }
            });

            bubblesToShow = tempArray;
          }
        );

        bubblesToShow.map((property: any, index: number) => {
          if (
            this.props.avalabilityAttributesToShow.includes(
              property.availability
            )
          ) {
            tempAvailabilityArray.push(property);
          }
        });

        bubblesToShow = tempAvailabilityArray;

        return bubblesToShow.map((property: any, index: number) =>
          property.verts.length === 4 ? (
            <polygon
              key={index + "layouts"}
              points={
                property.verts[0][0] +
                "," +
                property.verts[0][1] +
                " " +
                property.verts[1][0] +
                "," +
                property.verts[1][1] +
                " " +
                property.verts[3][0] +
                "," +
                property.verts[3][1] +
                " " +
                property.verts[2][0] +
                "," +
                property.verts[2][1] +
                " "
              }
              style={{
                cursor: "pointer",
                fill:
                  property.availability === "DISPONIBLE" && this.props.hasDispo
                    ? `hsla(${120}, ${100}%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 70
                          : 50
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.65
                          : 0.3
                      })`
                    : property.availability === "RESERVADO" &&
                      this.props.hasDispo
                    ? `hsla(${36}, ${84}%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 58
                          : 50
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.65
                          : 0.3
                      })`
                    : property.availability === "VENDIDO" && this.props.hasDispo
                    ? `hsla(${0}, ${100}%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 70
                          : 50
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.65
                          : 0.3
                      })`
                    : property.availability === "NO DISPONIBLE" &&
                      this.props.hasDispo
                    ? `hsla(${0}, ${0}%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 20
                          : 0
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.65
                          : 0.3
                      })`
                    : property.values[this.state.attributeId] !== undefined &&
                      property.values[this.state.attributeId] !== null &&
                      this.state.colorsObject[
                        property.values[this.state.attributeId]
                      ] !== undefined
                    ? `hsla(${
                        this.state.colorsObject[
                          property.values[this.state.attributeId]
                        ].h
                      }, ${
                        this.state.colorsObject[
                          property.values[this.state.attributeId]
                        ].s
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? this.state.colorsObject[
                              property.values[this.state.attributeId]
                            ].l + 20
                          : this.state.colorsObject[
                              property.values[this.state.attributeId]
                            ].l
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.65
                          : 0.3
                      })`
                    : `hsla(${this.state.hslColor.h}, ${
                        this.state.hslColor.s
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? this.state.hslColor.l + 20
                          : this.state.hslColor.l
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.65
                          : 0.3
                      })`,
                stroke:
                  property.availability === "DISPONIBLE" && this.props.hasDispo
                    ? `hsla(${120}, ${100}%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 70
                          : 50
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.8
                          : 0.65
                      })`
                    : property.availability === "VENDIDO" && this.props.hasDispo
                    ? `hsla(${0}, ${100}%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 70
                          : 50
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.8
                          : 0.65
                      })`
                    : property.availability === "RESERVADO" &&
                      this.props.hasDispo
                    ? `hsla(${36}, ${84}%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 58
                          : 50
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.8
                          : 0.65
                      })`
                    : property.availability === "NO DISPONIBLE" &&
                      this.props.hasDispo
                    ? `hsla(${0}, ${0}%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 20
                          : 0
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.8
                          : 0.65
                      })`
                    : property.values[this.state.attributeId] !== undefined &&
                      property.values[this.state.attributeId] !== null &&
                      this.state.colorsObject[
                        property.values[this.state.attributeId]
                      ] !== undefined
                    ? `hsla(${
                        this.state.colorsObject[
                          property.values[this.state.attributeId]
                        ].h
                      }, ${
                        this.state.colorsObject[
                          property.values[this.state.attributeId]
                        ].s
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? this.state.colorsObject[
                              property.values[this.state.attributeId]
                            ].l + 20
                          : this.state.colorsObject[
                              property.values[this.state.attributeId]
                            ].l
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.65
                          : 0.3
                      })`
                    : `hsla(${this.state.hslColor.h}, ${
                        this.state.hslColor.s
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? this.state.hslColor.l + 20
                          : this.state.hslColor.l
                      }%, ${
                        this.state.currentSelectedProperty === property.id
                          ? 0.65
                          : 0.3
                      })`,
                strokeWidth: 2,
                animation:
                  this.state.currentSelectedProperty === property.id
                    ? "fadeAnimation 2s linear infinite"
                    : "",
              }}
              onMouseUp={(e) => {
                this.setState({
                  currentSelectedProperty: property.id,
                });
                var isRigth = e.clientX > window.screen.width / 2;
                this.props.handleShowTooltip(
                  property.id,
                  e,
                  isRigth ? property.verts[0][0] : property.verts[1][0],
                  10
                );
              }}
              data-type={"INMUEBLE"}
              data-value={property.id}
            ></polygon>
          ) : (
            <text
              x={property.verts[0]}
              y={property.verts[1]}
              text-anchor="middle"
              alignment-baseline="middle"
              font-size="0.8rem"
              fill="white"
              onClick={(e) => {
                this.setState({
                  currentSelectedProperty: property.id,
                });
                var isRigth = e.clientX > window.screen.width / 2;
                this.props.handleShowTooltip(
                  property.id,
                  e,
                  property.verts[0],
                  5,
                  isRigth
                );
              }}
            >
              {property.values[property.id]}
            </text>
          )
        );
      }
    }
  };

  render(): React.ReactNode {
    return (
      <div
        className={
          this.props.showLayouts
            ? "layouts-property fade-in"
            : "layouts-property fade-out"
        }
      >
        {this.state.showLayouts ? (
          <svg
            width={"100%"}
            height={"100%"}
            preserveAspectRatio="xMidYMid slice"
            viewBox="0 0 2000 1400"
            id={"properties-layout"}
            style={{
              overflow: "hidden",
              pointerEvents: "none",
              position: "absolute",
            }}
          >
            <g
              style={{
                pointerEvents:
                  this.state.isMouseDown && this.state.isMouseMoving
                    ? "none"
                    : "visibleFill",
              }}
            >
              {this.createLayouts()}
            </g>
          </svg>
        ) : null}
      </div>
    );
  }
}

export default PropertiesLayouts;
